const isElectron=()=> {
    if (typeof navigator === 'object' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }
}


const shimFileToFile=async(file:any) => {
    try {
        const response = await fetch('safe-file://'+file.path);
        if (!response.ok) throw new Error(`Failed to fetch video: ${response.statusText}`);
        const blob = await response.blob();
        const newFile = new File([blob], file.name, { type: file.type });
        newFile.path = file.path;
        return newFile;
      } catch (error:any) {
        console.error(`Error fetching file data: ${error.message}`);
        throw error;
      }
}
export { isElectron , shimFileToFile};